export const handleKeyPress = (e,key,func) => {
    if (e.key == key) {
      func();
    }
  };